import React from 'react';
import { Loader } from '@components/index';
import loadable from '@loadable/component';

export default loadable(() => import('./ResidualContainer'), {
    fallback: <Loader />
});
